import { useAppDispatch } from "../../../../../redux/hooks";
import ActionMenu, {
  ActionMenuItem,
} from "../../../../../components/actionMenu/ActionMenu";
import { getSyncronizeInvoices } from "../../../../../redux/api/external.api";

function DeliveryArrangementActionButton(props: any) {
  const dispatch = useAppDispatch();

  const handleSyncronizeInvoices = () => {
    dispatch(
      getSyncronizeInvoices({
        op: props.crudData.Op,
      }),
    );
  };

  const items: ActionMenuItem[] = [
    {
      id: "resync-invoices",
      label: "Resincronizeaza facturile",
      icon: "RESYNC",
      tooltip:
        "Reincarca din ERP facturile si pozitiile de produse ale comenzii, dupa confirmare.",
      withConfirmationModal: {
        modalLeftButtonVariant: "outlined",
        modalTitle: `Doriti sa resincronizati facturile din comanda nr: ${props.crudData.id}?`,
        modalRightButtonOnClick: handleSyncronizeInvoices,
      },
    },
  ];

  return (
    <ActionMenu
      items={items}
      minItemsForMenu={2}
      title={`Comanda ${props.crudData.id}`}
      ariaLabel={`Actiuni pentru comanda ${props.crudData.id}`}
    />
  );
}

export default DeliveryArrangementActionButton;
